import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { finalize, firstValueFrom } from 'rxjs';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../core/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-recuperar-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatIcon,
  ],
  templateUrl: './recuperar-password.html',
  styleUrl: './recuperar-password.scss',
})
export class RecuperarPassword {
  private readonly fb = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  cargando = false;
  enviado = false;
  error = '';

  readonly form = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email, Validators.maxLength(254)]],
  });

  volverLogin(): void {
    this.router.navigate(['/login']);
  }

  async enviarEmail() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { email } = this.form.value;

    try {
      const res = await firstValueFrom(this.authService.recuperarPassword(`${email}`));

      await Swal.fire({
        icon: 'success',
        title: 'Enlace enviado correctamente',
        showConfirmButton: false,
        timer: 1000,
        customClass: {
          title: 'mi-swal-title',
          htmlContainer: 'mi-swal-text',
        },
      });

      this.router.navigate(['/login']);
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Inicio de sesión fallida',
        text: error['error']?.message ?? 'Credenciales incorrectas',
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          title: 'mi-swal-title',
          htmlContainer: 'mi-swal-text',
        },
      });
    }
  }
}
